import React from 'react';
import { Play } from 'lucide-react';

function getEmbedUrl(url) {
  if (!url) return null;
  // YouTube
  const yt = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  // Vimeo
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return url;
}

export default function ShowcaseVideo({ rig }) {
  const embed = getEmbedUrl(rig.showcase_video_url);
  if (!embed) return null;

  return (
    <section className="py-20 px-6 lg:px-10 border-t border-white/5 bg-[#111115]">
      <div className="max-w-7xl mx-auto">
        <p className="text-primary text-xs font-bold tracking-widest mb-3 flex items-center gap-2">
          <Play className="w-3.5 h-3.5" /> VIDEO SHOWCASE
        </p>
        <h2 className="text-white font-black text-3xl md:text-4xl uppercase mb-10">See It In Action</h2>

        <div className="relative aspect-video w-full bg-black border border-white/10 overflow-hidden">
          <iframe
            src={embed}
            title={`${rig.name} showcase video`}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
}